export const RULES_KEY_SEPARTOR = '##';